import React, { useEffect, useState } from 'react';
import styles from './SubscriptionQuantityUpdate.module.scss';
import Button from 'components/shared/Button';
import { toast } from 'react-toastify';

interface SubscriptionQuantityUpdateProps {
  quantity: number;
  activeMembersCount: number;
  handleQuantityChange: (newQuantity: number) => void;
}

const SubscriptionQuantityUpdate: React.FC<SubscriptionQuantityUpdateProps> = ({ quantity, activeMembersCount, handleQuantityChange }) => {
  const [localQuantity, setLocalQuantity] = useState(quantity);
  const [inputValue, setInputValue] = useState(quantity.toString());

  useEffect(() => {
    setLocalQuantity(quantity);
    setInputValue(quantity.toString());
  }, [quantity]);

  const handleIncrement = (change: number) => {
    const newQuantity = localQuantity + change;
    if (newQuantity >= 1 && newQuantity >= activeMembersCount) {
      setLocalQuantity(newQuantity);
      setInputValue(newQuantity.toString());
      handleQuantityChange(newQuantity);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleInputBlur = () => {
    const parsedValue = parseInt(inputValue, 10);

    if (parsedValue < 1) {
      toast.error('Subscription seats cannot be less than 1');
      setInputValue(localQuantity.toString());
      return;
    }
    if (parsedValue < activeMembersCount) {
      toast.error('Subscription seats cannot be less than active members count');
      setInputValue(localQuantity.toString());
      return;
    }

    setLocalQuantity(parsedValue);
    handleQuantityChange(parsedValue);
  };

  const getTitle = () => {
    if (localQuantity <= 1) {
      return 'Subscription seats cannot be less than 1';
    }
    if (localQuantity <= activeMembersCount) {
      return 'Please delete or deactivate some users first';
    }
    return '';
  };

  const buttonStyle = { width: 32, height: 32, borderRadius: 4 };

  return (
    <div className={styles.teamMembersControl}>
      <label className={styles.title}>User seats:</label>
      <Button
        title={getTitle()}
        variant='primary'
        style={buttonStyle}
        onClick={() => handleIncrement(-1)}
        disabled={quantity <= 1 || quantity <= activeMembersCount}
      >
        -
      </Button>

      <input
        className={styles.quantityInput}
        type="number"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
      />
      <Button
        variant='primary'
        style={buttonStyle}
        onClick={() => handleIncrement(1)}
      >
        +
      </Button>
    </div>
  );
};

export default SubscriptionQuantityUpdate;
